"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_interchangable__batteries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a2ca608c-d652-4a59-979c-cf9e42eb861e",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "interchangable-batteries-mid"), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 192,
    height: 192,
    transform: "translate(192 193) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fedf51a3-0366-47e8-8374-dcbfac1ce5bc",
    "data-name": "4a9248ed-2f37-49aa-853a-9e1bb76af86c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d8d64ee0-6f7f-48d8-8917-834afeb7f983",
    "data-name": "82438515-5e2f-4f28-b5b9-ac717ca22440",
    d: "M130.25,105.94a26.1,26.1,0,0,1-52.2,0V94",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "ba03b050-af66-4d27-95a4-0d46a1909303",
    "data-name": "26b5a8e2-44db-4906-9e03-c8a1039059ce",
    points: "90.25 106.24 78.05 94 66 106.05",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.05
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.13,57.5V48.57A6.57,6.57,0,0,0,87.56,42h-19A6.57,6.57,0,0,0,62,48.57V57.5",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.13,144.92v15.49a9.87,9.87,0,0,1-9.87,9.87H55.86A9.87,9.87,0,0,1,46,160.41V67.88A9.86,9.86,0,0,1,55.86,58h44.4a9.86,9.86,0,0,1,9.87,9.86v40",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,42V32.57A6.57,6.57,0,0,0,127.41,26h-19a6.57,6.57,0,0,0-6.57,6.57V42",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.14,65.6",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,42H140.2a9.86,9.86,0,0,1,9.86,9.86v92.41a9.85,9.85,0,0,1-9.86,9.86H110.13",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 86,
    x2: 78,
    y2: 70,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 78,
    x2: 70,
    y2: 78,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 154,
    x2: 70,
    y2: 154,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_interchangable__batteries;
exports.default = _default;